module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-group element-bodymatter element-type-volume element-without-heading",
    attrs: {
      "id": "vol-001"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "vol-001-text"
    }
  }, [_c('div', {
    staticClass: "inline-image inline-image-kind-freestanding inline-image-size-full inline-image-flow-center inline-image-aspect-tall inline-image-without-caption inline-image-begins-section"
  }, [_c('div', {
    staticClass: "inline-image-container"
  }, [_c('img', {
    attrs: {
      "alt": "Holding Myself",
      "src": "images/holding-myself-final.jpg"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a7d7fb5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vol-001.vue
// module id = 66
// module chunks = 0